import {
  styled,
  useProps,
  useTheme
} from "@tamagui/core";
import { YStack } from "@tamagui/stacks";
import {
  LinearGradient as ExpoLinearGradient
} from "./linear-gradient";
import { jsx } from "react/jsx-runtime";
const LinearGradient = YStack.styleable(
  (propsIn, ref) => {
    const props = useProps(propsIn), { start, end, colors: colorsProp, locations, children, ...stackProps } = props, theme = useTheme(), colors = props.colors?.map((c) => theme[c]?.get("web") ?? c) || [];
    return /* @__PURE__ */ jsx(LinearGradientFrame, { ref, ...stackProps, children: /* @__PURE__ */ jsx(
      ExpoLinearGradient,
      {
        start,
        end,
        colors,
        locations,
        style: absoluteFill,
        children
      }
    ) });
  }
), absoluteFill = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}, LinearGradientFrame = styled(YStack, {
  name: "LinearGradient",
  overflow: "hidden",
  position: "relative"
});
export {
  LinearGradient
};
//# sourceMappingURL=LinearGradient.shared.js.map
